import Service from '@/services/movements.service'

const state = {
    filterLoading: false,
    stockState: {}
}

const getters = {}

const actions = {
    async read({ commit }, args) {
        try {
            commit('reading')
            const response = await Service.getState(args)
            commit('readStockStateSuccess', response.data)
            return true
        } catch (e) {
            const status = e && e.response ? e.response.status : 500
            return status
        }
    },
}

const mutations = {
    reading(state) {
        state.filterLoading = true
    },
    readStockStateSuccess(state, data) {
        state.stockState = data
        state.filterLoading = false
    }
}

const movements = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default movements
